import {TweenLite} from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

/**
 * Custom scroll
 * par ce qu'on utilise pas le scroll du navigateur
 * mais la div MainContainer
 */

export default {
  install (Vue, options) {
    const _scrollTo = (y, offset = 0) => {
        TweenLite.to(document.querySelector('.MainContainer'), 1.6, {
          scrollTo: (y - offset)
        })
      },
      _getCurrentScroll = () => {
        return document.querySelector('.MainContainer').scrollTop
      },
      _getElementOffsetY = (el) => {
        return el.getBoundingClientRect().top + _getCurrentScroll()
      },
      _isElement = (el) => {
        return el instanceof Element
      }

    const $scroll = {
      /**
       * Scroll to a target
       *
       * @param  {Number|String|Element|Array} target - target jusqu'à laquelle scroller
       * @param  {Number} offset - offset du scroll par rapport au haut de la fenêtre du navigateur
       *
       * @return {void}
       */
      to (target, offset = 0) {
        let yTo, el

        if (typeof target === 'number') {
          yTo = target
        } else if (typeof target === 'string') {
          el = document.querySelector(target)
        } else if (_isElement(target)) {
          el = target
        } else if (target.length && target.length > 1 && _isElement(target[0])) {
          el = target[0]
        }

        if (el) {
          yTo = _getElementOffsetY(el)
        }

        if (yTo) {
          _scrollTo(yTo, offset)
        }
      },
      getElementOffsetY: _getElementOffsetY,
      getCurrentScroll: _getCurrentScroll
    }

    Vue.prototype.$scroll = $scroll
    Vue.$scroll = $scroll
  }
}
